// extracted by mini-css-extract-plugin
export default {"root":"_2Uq7K","visible":"_13mpf"};